export default [
  {
    type: 'input',
    placeholder: '账号',
    filed: 'account',
    default: ''
  }
]
